import React from 'react';
import { Link } from 'react-router-dom';
import './EngagementHub.css';

const collateralRequestUrl = (asset) => `/?engagement=collateral&asset=${encodeURIComponent(asset)}#contact`;

const EngagementHub = () => (
  <section className="engagement-hub" aria-labelledby="engagement-title">
    <div className="engagement-hub__inner">
      <div className="engagement-hub__heading">
        <p className="engagement-hub__eyebrow">TAKE THE NEXT STEP</p>
        <h2 id="engagement-title">Explore what’s possible with AIVION</h2>
        <p>See a platform in action, arrange a conversation, or get a relevant case study sent to your inbox.</p>
      </div>
      <div className="engagement-hub__actions">
        <Link className="engagement-card" to="/aivionscore">
          <span className="engagement-card__icon" aria-hidden="true">▶</span>
          <span className="engagement-card__title">Explore product tours</span>
          <span className="engagement-card__copy">See how our platforms work through interactive guided tours.</span>
          <span className="engagement-card__link">Explore products <span aria-hidden="true">→</span></span>
        </Link>
        <a className="engagement-card" href="mailto:info@aivion.ai?subject=Meeting%20request%20with%20AIVION&body=Hello%20AIVION%2C%0A%0AI%E2%80%99d%20like%20to%20arrange%20a%20meeting.%20Please%20share%20some%20available%20times.%0A%0ACompany%3A%20%0ATopics%20to%20discuss%3A%20">
          <span className="engagement-card__icon" aria-hidden="true">◷</span>
          <span className="engagement-card__title">Request a meeting</span>
          <span className="engagement-card__copy">Tell us what you’re working on and we’ll coordinate a suitable time.</span>
          <span className="engagement-card__link">Email our team <span aria-hidden="true">→</span></span>
        </a>
        <Link className="engagement-card" to={collateralRequestUrl('AIVION capabilities overview')}>
          <span className="engagement-card__icon" aria-hidden="true">↓</span>
          <span className="engagement-card__title">Request a tailored brief</span>
          <span className="engagement-card__copy">Ask us to send information matched to your industry or use case.</span>
          <span className="engagement-card__link">Request by email <span aria-hidden="true">→</span></span>
        </Link>
      </div>
    </div>
  </section>
);

export default EngagementHub;
